module.exports = __webpack_public_path__ + "static/media/home.b9cc4efc.svg";